import React from "react";

interface LayoutFullWidthProps {
    children?: React.ReactNode;
    className?: string;
}

export const LayoutFullWidth: React.FC<LayoutFullWidthProps> = ({
                                    children,
                                    className = "",
                                }: LayoutFullWidthProps) => {

    return <>
        <div className={`l-fullwidth l-fullwidth--white ${className}`}>
            <div className={`l-fullwidth__background`}></div>

            <div className={`l-fullwidth__content`}>
                {children}
            </div>
        </div>
    </>
        ;
};
